<template>
  <div class="property-row">
    <span><strong><span v-if="this.isRequired">*</span>{{ title }}:</strong></span>
    <input
      :id="propName"
      :type="this.type || 'text'"
      :disabled="disabled === true"
      :class="['form-control', (this.validationError ? 'invalid' : '')].join(' ')"
      @keyup="onChange"
      @change="onChange"
      :value="getValue(this.propName)"
      :placeholder="this.placeholder"
    />
  </div>
</template>

<script>

  export default {
    name: 'PropertyInput',
    props: ['title', 'propName', 'disabled', 'getValue', 'setValue', 'validationError', 'type', 'placeholder', 'required'],
    methods: {
      onChange(evt) {
        this.setValue(this.propName, evt.target.value);
      },
    },
    computed: {
      isRequired() {
        return this.required == null || this.required;
      }
    }
  }
</script>